// Avatar color palette + initials helper, ported from support.js av().

const PALETTE: Record<string, [string, string]> = {
  a: ['var(--accent-bg)', 'var(--accent)'],
  i: ['var(--info-bg)', 'var(--info)'],
  s: ['var(--success-bg)', 'var(--success)'],
  w: ['var(--warning-bg)', 'var(--warning)'],
  n: ['var(--surface-3)', 'var(--text-2)'],
};

export interface Avatar {
  in: string;
  bg: string;
  fg: string;
}

export function initials(name?: string | null): string {
  if (!name) return '—';
  const ini = name
    .trim()
    .split(/\s+/)
    .map((w) => w[0] || '')
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return ini || '—';
}

export function av(name?: string | null, kind: string | null = 'n'): Avatar {
  const p = PALETTE[kind || 'n'] || PALETTE.n;
  return { in: initials(name), bg: p[0], fg: p[1] };
}

// Deterministic kind from a string, so records without an explicit color still
// get a stable avatar tint.
export function kindFor(seed: string): string {
  const kinds = ['a', 'i', 's', 'w', 'n'];
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return kinds[h % kinds.length];
}
